// extracted by mini-css-extract-plugin
export var contentBody = "_43-9";
export var headerImage = "_43-2";
export var imageButton = "_43-7";
export var imageButtonIcon = "_43-8";
export var imageHeader = "_43-4";
export var imageHeaderText = "_43-5";
export var imageOverlay = "_43-3";
export var imageTitle = "_43-6";
export var imageWrapper = "_43-1";
export var taskList = "_43-a";
export var widget = "_43-0";